export default __webpack_public_path__ + "static/media/sip.5a615875.svg";